module.exports = __webpack_public_path__ + "img/bplogo.6aac7fc7.svg";